/**
 * Demo view — a PER-BROWSER presentation mode.
 *
 * When on, a handful of store actions (reservations, contract detail, the
 * Analytics hub, journey responses) return generated demo data instead of
 * calling the API. Nothing is sent to the backend, nothing changes for other
 * users — the flag lives in THIS browser's localStorage only.
 *
 * Toggled from Organization settings → Demo (admins only). Pages read their
 * data on mount, so the toggle reloads the page to flip everything at once.
 */
const KEY = 'crmDemoView'

export default {
  enabled() {
    try {
      return localStorage.getItem(KEY) === 'on'
    } catch (e) {
      return false
    }
  },
  set(on) {
    try {
      if (on) localStorage.setItem(KEY, 'on')
      else localStorage.removeItem(KEY)
    } catch (e) { /* private mode — demo simply stays off */ }
  },
}
